module.exports = __webpack_public_path__ + "static/img/tjbgshu.def3e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/tjbgshu.jpg
// module id = OY7p
// module chunks = 9